<template>
  <div>
    <el-row class="cs-contentContainer">
      <el-col
        :span="4"
        class="cs-main-left-container"
      >
        <navigator></navigator>
      </el-col>
      <el-col
        :span="20"
        class="backgroud-gray cs-fullHeight cs-main-right-container"
      >
        <div class="cs-fullHeight cs-contentContainer-right">
          <div
            class="backgroud-white cs-contentContainer-right-content cs-fullHeight"
            v-loading="loading"
          >
            <el-row>
              <el-col>
                <el-steps
                  :active="activeStep"
                  process-status="finish"
                  finish-status="success"
                  simple
                >
                  <el-step
                    title="学生信息"
                    :status="getStepStatus(0)"
                    @click.native="onStepItemClick(0)"
                  ></el-step>
                  <el-step
                    title="添加占位"
                    :status="getStepStatus(1)"
                    @click.native="onStepItemClick(1)"
                  ></el-step>
                  <el-step
                    title="缴付款项"
                    :status="getStepStatus(2)"
                    @click.native="onStepItemClick(2)"
                  ></el-step>
                  <el-step
                    title="占位成功"
                    :status="getStepStatus(3)"
                    @click.native="onStepItemClick(3)"
                  ></el-step>
                </el-steps>
              </el-col>
            </el-row>
            <hr>
            <el-row class="grid-content">
              <el-col>
                <workflowStep1 ref="workflowStep1" v-show="activeStep===0" :dataIn="step1Model" @reload="onReload" @buyMemberCard="onBuyMemberCard"></workflowStep1>
                <workflowStep2 ref="workflowStep2" v-show="activeStep===1" :isCalculating="isCalculating" :discountListData="discountListData" studentId="this.memberModel.StudentId" :dataIn="step2Model" @calculate="onCalculate"></workflowStep2>
                <workflowStep3 ref="workflowStep3" v-show="activeStep===2 || activeStep===3" :dataIn="step3Model" @save="onSaveStep3" @savePaymentStart="onSavePaymentStart" @savePaymentEnd="onSavePaymentEnd"></workflowStep3>
              </el-col>
            </el-row>
            <el-row class="cs-filter-row">
              <el-col :span="24">
                <el-button v-if="!workflowCompleted" size="medium" :loading="isCalculating || isSaving" :disabled="submitBtnDisable || isCalculating || isSaving" :type="submitBtnClass" @click="next">{{submitBtnText}}</el-button>
                <el-button v-if="!workflowCompleted && activeStep===2" size="medium" type="danger" @click="onCancelWorkflow">撤销</el-button>
                <el-button v-if="activeStep!=0" size="medium" type="danger" @click="onRedoWorkflow">新建流程</el-button>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog :center="true" :close-on-click-modal="false" width="600px" :visible.sync="completedVisible" top="3vh" class="completedMessage">
      <el-row>
        <el-col>
          <img src="../../assets/success.png" />
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <!-- <span>课程报名成功，电子收据已发送至{{dataIn.memberModel.Email}}</span> -->
          <span>占位报名成功</span>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-button type="primary" @click="onCompletedDialogClose">完成</el-button>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<style lang="scss" scoped>
.el-col {
  span {
    height: 40px;
    line-height: 40px;
  }
}

.el-button {
  margin-left: 20px;
}

.completedMessage {
  .el-row {
    padding: 30px;

    .el-col {
      text-align: center;
    }
  }
}
</style>

<script>
import { arrayEquals,getCourseTypeText } from "../../config/mUtils";
import { getFormulaListByType } from "../../service/finance.service";
import { getGlobalPriceSettings } from "../../service/globalPriceSetting.service";
import { getIntroducers } from "../../service/common.service";
import {
  getBonusPointMechanismByType,
} from "../../service/bonusPoint.service";
import { createWorkflowModel,getActiveWorkflowDataByStudentId, 
  calculateEnrollmentFee, saveWorkflowData,removeWorkflow } 
  from "../../service/enrollmentFee.service";
import navigator from "../../components/navigator";
import workflowStep1 from "../../components/addCollectFees/advanceEnrollmentFee/aefWorkflowStep1";
import workflowStep2 from "../../components/addCollectFees/advanceEnrollmentFee/aefWorkflowStep2";
import workflowStep3 from "../../components/addCollectFees/advanceEnrollmentFee/aefWorkflowStep3";
export default {
  inject:['reload'],
  data() {
    return {
      loading: false,
      isCalculating: false,
      activeStep: 0,
      lastStep: 0,
      currentStepCompleted: false,
      submitBtnClass: "info",
      submitBtnDisable: true,
      completedVisible: false,
      priceSettings: {
        memberCardPrice: 0,
        memberCardPriceAfterDiscount:0,
        adEnrollmentPrice: 0,
        paymentCommissionRate: 0,
        bonusPointToMoney_Money:0,
        bonusPointToMoney_BonusPoint:0,
        trainingAdEnrollmentPrice:0
      },
      hasBuyMemberCard: false,
      memberModel: {},
      workflowOriginalData:{},
      workflowData: {
        CurrentStep: 0,
      },
      step1Model:{
        hasBuyMemberCard:false
      },
      step2Model:{},
      step3Model:{},
      discountList:null,
      trainingDiscountList:null,
      discountListData:{},
      calculateResult:null,
      isSaving: false,
      isEditing: false,
      isEditingCompleted: false,
      introducers:[]
    };
  },
  components: {
    navigator,
    workflowStep1,
    workflowStep2,
    workflowStep3
  },
  computed: {
    submitBtnText: function() {
      let text = "下一步";

      if (this.activeStep === 2 || this.activeStep === 3) {
        text = "完成付款";
      }

      return text;
    },
    workflowCompleted: function(){
      if (this.workflowData){
        return this.workflowData.IsCompleted  
          || (!this.isEditing && (this.workflowData.Status == 1 
          && this.step3Model && this.step3Model.modelData && this.step3Model.modelData.isAutonomousPayment)
          || (this.isEditing && this.isEditingCompleted));
      }
      return false;
    }
  },
  created() {
    this.loadIntroducers();
    this.loadPriceSettings();
    this.getDiscountList();
    this.step2Model = this.getEmptyStep2Model();
  },
  mounted(){
    if (!!this.$route.query.studentId){
      this.$refs["workflowStep1"].searchStudentMemberInfoById(this.$route.query.studentId, this.$route.query.workflowId);
    }
  },
  methods: {
    init(workflowId){
      this.isEditingCompleted = false;
      if (workflowId){
        this.isEditing = true;
      }else{
        this.isEditing = false;
      }
      this.loadWorkflowData(workflowId);
    },
    initStepModel(){
      this.workflowOriginalData = JSON.parse(JSON.stringify(this.workflowData));
      
      if (!this.workflowData.IsCompleted && this.workflowData.CurrentStep == 3){
        this.activeStep = 2;
      }else{
        this.activeStep = this.workflowData.CurrentStep;
      }
      this.initStep1Model();
      this.initStep2Model();
      this.initStep3Model();
    },
    initStep1Model(){
      let model = {hasBuyMemberCard: false}
      if (!!this.workflowData && this.workflowData.MemberCardPrice > 0){
        model.hasBuyMemberCard = true;
        this.hasBuyMemberCard = true;
      }else{
        this.hasBuyMemberCard = false;
      }
      this.step1Model = model;
    },
    initStep2Model(){
      let model = null;
      if (!!this.workflowData && this.workflowData.Id > 0){
        model = {
          isCompleted: this.workflowData.IsCompleted,
          hasBuyMemberCard: this.hasBuyMemberCard,
          priceSettings:this.priceSettings,
          modelData:{
            courseType: this.workflowData.CourseType,
            selectedDiscountList: this.workflowData.WorkflowDiscounts.map(i =>{return i.FormulaFieldId;}),
            advanceEnrollmentCount: this.workflowData.AdvanceEnrollmentCount,
            selectedAdvanceEnrollmentId: this.workflowData.SelectedAdvanceEnrollmentId,
            contractId: this.workflowData.ContractId,
            studentId: this.memberModel.StudentId
          },
          priceData:{
            totalPrice:this.workflowData.AdvanceEnrollmentPrice,
            discountPrice:this.workflowData.AdvanceEnrollmentPrice
          }
        };
      }else{
        model = this.getEmptyStep2Model();
      }
    
      this.step2Model = model;
    },
    getEmptyStep2Model(){
      let model = {
          isCompleted: false,
          hasBuyMemberCard: this.hasBuyMemberCard,
          priceSettings:this.priceSettings,
          modelData:{
            courseType: 1,
            selectedDiscountList: [],
            advanceEnrollmentCount: 0,
            selectedAdvanceEnrollmentId: "",
            contractId: "",
            studentId: this.memberModel.StudentId
          },
          priceData:{
            totalPrice:0,
            discountPrice:0
          }
        };
      return model;
    },
    initStep3Model(){ 
      let memberCardDiscountPrice = this.workflowData.BuyMemberCardPrice; 
      let accountType = 1;
      if (this.workflowData.CourseType == 3){
        accountType = 8;
      }
      let discountList = this.getSelectedDiscount();
      let aeTotalPrice = this.getVariableResultValue(this.calculateResult, "AdvanceEnrollmentTotalPrice");
      let aeDiscountPrice = this.getVariableResultValue(this.calculateResult, "AdvanceEnrollmentDiscountPrice");
   
      let model = {
        isCompleted: this.workflowData.IsCompleted,
        accountType:accountType,
        courseType: this.workflowData.CourseType,
        workflowId:this.workflowData.Id,
        memberModel:this.memberModel,
        enrollmentCount: this.workflowData.AdvanceEnrollmentCount,
        aeTotalPrice: aeTotalPrice,
        aeDiscountPrice: aeDiscountPrice,
        priceSettings:this.priceSettings,
        discountList: discountList,
        memberCardModel:{
          hasBuyMemberCard:this.hasBuyMemberCard,
          memberCardDiscountPrice: memberCardDiscountPrice,
        },
        modelData:{
          enrollmentCount: 0,
          balance:this.workflowData.BalanceCost,
          bonusPoint:this.workflowData.BonusPointCost,
          cashDecreased:this.workflowData.CashDecreasedAmount,
          comment:this.workflowData.Comment,
          isAutonomousPayment: this.workflowData.IsAutonomousPayment,
          paymentType: this.workflowData.PaymentType,
          qrCodeImage: this.workflowData.QRCodeImage,
          introducerId: this.workflowData.IntroducerId
        },
        workMode:'',
        introducers: this.introducers
      };
      this.step3Model = model;
    },
    findDiscountFormula(name) {
      let result = null;
      let list = this.discountList;
      if (this.workflowData.CourseType == 3){
        list = this.trainingDiscountList;
      }
      for (let i = 0; i < list.length; i++) {
        let formulaModel = list[i];
        if (formulaModel.VariableName == name && !formulaModel.IsBonusPoint) {
          result = list[i];
          break;
        }
      }

      return result;
    },
    getSelectedDiscount(){
      let list = [];
      if (!!this.calculateResult){
        for (let i = 0; i < this.calculateResult.length; i++) {
          let variableResult = this.calculateResult[i];
          let formulaModel = this.findDiscountFormula(variableResult.Name);
          if (formulaModel == null) continue;

          list.push({
            name: variableResult.Name,
            labelName: formulaModel.LabelName,
            mapName: variableResult.MapName,
            value: variableResult.Value,
            discount: variableResult.Discount,
            description: variableResult.Description
          });
        }
      }

      return list;
    },
    getDisountListFromStep2(){
      let list = [];
      if (!!this.step2Model && !!this.step2Model.modelData && !!this.step2Model.modelData.selectedDiscountList){
        this.step2Model.modelData.selectedDiscountList.forEach(element => {
          let item = {
            FormulaFieldId: element
          };
          list.push(item);
        });
      }
      return list;
    }, 
    async calculatePrice(isInit){     
      if (!isInit){
        this.setValueForWorkflowModel();
      }

      if (this.workflowData.CourseType == 0){
        return;
      }

      if ((this.workflowData.CourseType == 1)  && !this.workflowData.SelectedAdvanceEnrollmentId){
        return;
      }

      this.isCalculating = true;
      let result = await calculateEnrollmentFee(this.workflowData);

      if (result && result.success){
        this.calculateResult = result.data;
        this.setCalculationPrice(result.data);
      }
      this.isCalculating = false;
    },
    setCalculationPrice(result){
      let membershipCardDiscountPrice = this.getVariableResultValue(result, "MembershipCardDiscountPrice");
      let membershifCardChange = false;
      if (this.workflowData.BuyMemberCardPrice != membershipCardDiscountPrice){
          this.workflowData.BuyMemberCardPrice = this.getVariableResultValue(result, "MembershipCardDiscountPrice");
          membershifCardChange = true;
      }

      if (!!this.step2Model){
        
        //this.$set(this.step2Model.priceData, "totalPrice",this.getVariableResultValue(result, "AdvanceEnrollmentTotalPrice"));
        //this.$set(this.step2Model.priceData, "discountPrice",this.getVariableResultValue(result, "AdvanceEnrollmentDiscountPrice"));
        this.step2Model.priceData.totalPrice = this.getVariableResultValue(result, "AdvanceEnrollmentTotalPrice");
        this.step2Model.priceData.discountPrice = this.getVariableResultValue(result, "AdvanceEnrollmentDiscountPrice");

        if (membershifCardChange){
          this.$refs["workflowStep2"].getDiscountListDisplayed();
        }
      }

      // if (!!this.step3Model){
      //   let discountlist = this.getSelectedDiscount();
      //   this.$set(this.step3Model, "discountList",discountList);
      //   this.$set(this.step3Model, "courseDiscountTotalPrice",this.getVariableResultValue(result, "CourseDiscountTotalPrice"));
      // }
      if (!!this.step3Model && !!this.step3Model.memberCardModel){
        this.$set(this.step3Model.memberCardModel, "hasBuyMemberCard",this.hasBuyMemberCard);
        this.$set(this.step3Model.memberCardModel, "memberCardDiscountPrice",this.workflowData.BuyMemberCardPrice);
        this.$refs["workflowStep3"].loadWorkflowInfoData();
      }
    },
    getVariableResultValue(result, name){
      if (!result){
        return 0;
      }

      let item = this.getVariableResult(result, name);
      if (!!item){
        return item.Value;
      }
      return 0;
    },
    getVariableResult(result, name){
      let item = result.filter(i => i.Name == name);
      if (item && item.length){
        return item[0];
      }
      return null;
    },
    setValueForWorkflowModel(){
      if (this.hasBuyMemberCard){
         this.workflowData.MemberCardPrice = this.priceSettings.memberCardPriceAfterDiscount;//memberCardPrice;
      }else{
        this.workflowData.MemberCardPrice = 0;
      }
      this.workflowData.CourseType = this.step2Model.modelData.courseType;
      this.workflowData.AdvanceEnrollmentCount = this.step2Model.modelData.advanceEnrollmentCount;
      if (this.workflowData.CourseType == 1){
        this.workflowData.SelectedAdvanceEnrollmentId = this.step2Model.modelData.selectedAdvanceEnrollmentId;
      }else{
        this.workflowData.SelectedAdvanceEnrollmentId = 0;
      }
      
      this.workflowData.StudentId = this.step2Model.modelData.studentId;
      this.workflowData.ContractId = this.step2Model.modelData.contractId;
      this.workflowData.WorkflowDiscounts = this.getDisountListFromStep2();
      if (!!this.step2Model.priceData){
        this.workflowData.AdvanceEnrollmentPrice = this.step2Model.priceData.totalPrice;
       //this.workflowData.AdvanceEnrollmentDiscountPrice = this.step2Model.priceData.discountPrice;
      }

      this.workflowData.BalanceCost = this.step3Model.modelData.balance;
      this.workflowData.BonusPointCost = this.step3Model.modelData.bonusPoint;
      this.workflowData.CashDecreasedAmount = this.step3Model.modelData.cashDecreased;
      this.workflowData.Comment = this.step3Model.modelData.comment;
      this.workflowData.IsAutonomousPayment = this.step3Model.modelData.isAutonomousPayment;
      this.workflowData.PaymentType = this.step3Model.modelData.paymentType;
      this.workflowData.QRCodeImage = this.step3Model.modelData.qrCodeImage;
      this.workflowData.IntroducerId = this.step3Model.modelData.introducerId;
    },
    onBuyMemberCard(data){
      this.hasBuyMemberCard = data.isBuy;
      this.$set(this.step2Model,"hasBuyMemberCard",this.hasBuyMemberCard);
      this.calculatePrice();
    },
    onReload(data, workflowId){
      if (!!data.memberModel && !!data.memberModel.StudentId){
        this.submitBtnDisable = false;
        this.submitBtnClass = "primary";
        this.memberModel = data.memberModel;
        this.hasBuyMemberCard = data.hasBuyMemberCard;
      }else{
        this.submitBtnDisable = true;
        this.submitBtnClass = "info";
        this.memberModel = {};
        this.hasBuyMemberCard = false;
      }
      this.init(workflowId);
    },
    onCalculate(){
      this.calculatePrice();
    },
    getStepStatus(step) {
      let stepStatus = "finish";

      if (step != this.activeStep) {
        stepStatus = "process";
        if (step < this.workflowData.CurrentStep) {
          stepStatus = "success";
        } else if (step > this.workflowData.CurrentStep) {
          stepStatus = "wait";
        } else if (this.workflowData.CurrentStep === 3 && step === 3) {
          stepStatus = "success";
        }
      }

      return stepStatus;
    },
    onStepItemClick(step) {
      if (step === this.activeStep || step > this.workflowData.CurrentStep)
        return;

      // if ((this.activeStep == 1 || this.activeStep == 2) && !this.workflowData.IsCompleted){
      //   let strOriginal = JSON.stringify(this.workflowOriginalData);
      //   let strCurrent = JSON.stringify(this.workflowData);
      //   if (strOriginal != strCurrent){

      //     this.$confirm("是否保存所做的修改?", "提示", {
      //       confirmButtonText: "确定",
      //       cancelButtonText: "取消",
      //       type: "warning"
      //       }).then(() => {
      //         this.saveCurrentStep();
      //     }).catch(() => {
              
      //       });;
      //   }
      // }

      this.activeStep = step;
    },
    async next() {
      let isSuccess = true;
      if (this.activeStep >= 1){
         isSuccess = await this.saveCurrentStep(true);
      }
      if (isSuccess){
        this.activeStep ++;
        if (this.activeStep == 2){
          this.initStep3Model();
        }
      }
    },
    validSave(isCompleted){
      let isValid = true;
      let message = "";
      if (this.activeStep == 1){
        isValid = this.$refs["workflowStep2"].checkAllInputs();
        if (!isValid){
          message = "";
        }

      }
      if (isCompleted){
        if (this.activeStep == 2){
          isValid = this.$refs["workflowStep3"].checkCompleteAvailable();
          if (!isValid){
            message = "要完成付款才能完成占位报名";
          }

          if (this.step3Model.modelData.isAutonomousPayment){
            let accountAmount = this.$refs["workflowStep3"].getAccountAmount();
            if (accountAmount == 0){
              isValid = false;
              message = "应付价格为0，请选择收费方式为 前台收费 后，完成占位";
            }
          }
        }
      }

     if ((this.workflowData.CourseType == 1 || this.workflowData.CourseType == 0) && !this.workflowData.SelectedAdvanceEnrollmentId){
        isValid = false;
        if (message.length > 0){
          message += ", ";
        }
        message = "请选择占位规则";
      }

      if (!isValid && !!message){
        this.$message({
          message: message,
          type: "warning"
          });
      }

      return isValid;
    },
    onSaveStep3(){
      this.saveCurrentStep(false);
    },
    async saveCurrentStep(isCompleted) {
      if (this.workflowData.IsCompleted) 
        return true;
       
      this.setValueForWorkflowModel();

      if (!this.validSave(isCompleted)){
        return false;
      }

      let isSave = true;
      switch (this.activeStep) {
        case 0:
          break;
        case 1:
          break;
        case 2:
        case 3:
          if (isCompleted){
            isSave = await this.$confirm("是否要完成该流程?", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
            }).then(() => {
              return true;
            }).catch(() => {
              return false;
            });
            if (isSave)
              if (this.step3Model && this.step3Model.modelData && this.step3Model.modelData.isAutonomousPayment){
                if (!this.workflowData.Status){
                  this.workflowData.Status = 1;
                }
                
                this.isEditingCompleted = true;
              }else{
                this.workflowData.IsCompleted = true;
              }
          }
          break;
      }

      if (!isSave){
        return;
      }

      let isSuccess = true;
      this.loading = true;
      this.setValueForWorkflowModel();
    
      if (isCompleted){ 
        let step = this.activeStep + 1;
        if (step > 3){
          step = 3;
        }

        if (this.workflowData.CurrentStep < step){
          this.workflowData.CurrentStep = step;
        }
      }

      this.isSaving = true;
      let result = await saveWorkflowData(this.workflowData); 
      this.isSaving = false;

      if (result && result.success){
        this.workflowData.Id = result.data.Id;
        this.workflowData.QRCodeImage = result.data.QRCodeImage;
        this.step2Model.isCompleted = this.workflowCompleted;
        this.step3Model.isCompleted = this.workflowCompleted;
        this.step3Model.modelData.qrCodeImage = this.workflowData.QRCodeImage;
        this.workflowOriginalData = JSON.parse(JSON.stringify(this.workflowData));

        if (this.workflowCompleted){
          this.showCompletedDialog();

          let member = await this.$refs["workflowStep1"].loadMemberInfo(false);
          this.memberModel = member;
         
          if (!!this.step3Model){
            this.$set(this.step3Model,"memberModel",member);
          }
        }
      }else{
        this.isEditingCompleted = false;
        this.workflowData.IsCompleted = false;
        this.$message({
          message: result.message,
          type: "error"
        });
        isSuccess = false;
      }
      this.loading = false;
  
      return isSuccess;
    },
    loadPriceSettings() {
      getBonusPointMechanismByType(2).then(result=>{
        if (result && result.success){
          this.priceSettings.bonusPointToMoney_Money = result.data.Money;
          this.priceSettings.bonusPointToMoney_BonusPoint = result.data.BonusPoint;
        }
      });
      getGlobalPriceSettings().then(result => {
        if (!!result && result.success) {
          this.priceSettings.memberCardPrice = this.findPriceByType(
            result.data,
            4
          );
          this.priceSettings.adEnrollmentPrice = this.findPriceByType(
            result.data,
            6
          );

          this.priceSettings.paymentCommissionRate = this.findPriceByType(
            result.data,
            5
          );
          this.priceSettings.trainingAdEnrollmentPrice = this.findPriceByType(
            result.data,
            10
          );
          this.priceSettings.memberCardPriceAfterDiscount = this.findPriceByType(
            result.data, 
            12
          );
        }
      });
    },
    findPriceByType(gpSettings, type) {
      let result = null;

      for (let i = 0; i < gpSettings.length; i++) {
        let gpSetting = gpSettings[i];
        if (gpSetting.Type === type) {
          result = gpSetting;
          break;
        }
      }

      return result != null ? result.Value : 0;
    },
    getDiscountList() {
      getFormulaListByType(1, 1).then(result=>{
        if (result && result.success){
           this.discountList = result.data;
        }else{
          this.discountList = [];
        }
        this.initDiscountListData();
      });

      getFormulaListByType(1, 8).then(result=>{
        if (result && result.success){
           this.trainingDiscountList = result.data;
        }else{
          this.trainingDiscountList = [];
        }
        this.initDiscountListData();
      });
    },
    initDiscountListData(){
      if (!!this.discountList && !!this.trainingDiscountList){
        this.discountListData = {
          discountList: this.discountList,
          trainingDiscountList: this.trainingDiscountList
        };
      }
    },
    async loadWorkflowData(workflowId) {
      let studentId = this.memberModel.StudentId;

      if (!studentId) {
        this.workflowData = createWorkflowModel(1);
        this.initStepModel();
      }else{
        this.loading = true;
        let result = await getActiveWorkflowDataByStudentId(studentId, 1, false, workflowId);
        if (!!result && result.success){
          this.workflowData = result.data;
          this.workflowData.EnrollmentType = 1;
          if (!!this.workflowData.Id){
            await this.calculatePrice(true);
          }
          
          this.initStepModel();
        }else{
          this.workflowData = createWorkflowModel(1);
          this.initStepModel();
        }
        this.loading = false;
      
      }
    },
    showCompletedDialog() {
      this.completedVisible = true;
    },
    onCompletedDialogClose() {
      this.completedVisible = false;
    },
    removeCurrentWorkFlow(forceCancel, callback){
      if(this.activeStep==1 && !forceCancel){
        this.activeStep = 0;
        this.$refs["workflowStep1"].searchStudentMemberInfoByPhone();
        return;
      }
      
      if (!!this.workflowData && !!this.workflowData.Id){
        this.loading = true;
        removeWorkflow(this.workflowData.Id).then(result=>{
          if (!!result && result.success){
            this.$message({
              message: "撤销流程成功",
              type: "success"
            });
            this.activeStep = 0;
            this.$refs["workflowStep1"].searchStudentMemberInfoByPhone();
            if (callback){
              callback();
            }
            //this.init();
          }else{
           this.$message({
              message: result.message,
              type: "error"
            });
          }
          this.loading = false;
        });
      }
    },
    onCancelWorkflow(){
      this.$confirm("是否撤销该流程?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
        }).then(() => {
          this.removeCurrentWorkFlow();
        }).catch(() => {
          
        });;
      
    },
    onRedoWorkflow(){
      if (this.workflowCompleted){
         this.redoCurrentWorkFlow();
      }else{
        let msg = "新建流程将撤销当前流程，是否继续?";
        this.$confirm(msg, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
          }).then(() => {
            this.redoCurrentWorkFlow();
          }).catch(() => {

          });
      }
    },
    redoCurrentWorkFlow(){
      if (!!this.workflowData.Id && !this.workflowCompleted){
        this.removeCurrentWorkFlow(true, () => {this.reloadPage();});
      }else{
        this.reloadPage();
      }
    
    },
    reloadPage(){
      this.reload();
    },
    onSavePaymentStart(){
      this.isSaving = true;
    },
    onSavePaymentEnd(){
      this.isSaving = false;
    },
    loadIntroducers(){
      getIntroducers().then(result =>{
        if (!!result && result.success){
          this.introducers = result.data;
          if (this.step3Model){
            this.step3Model.introducers = this.introducers;
          }
        }
      });
    },
  },
  watch: {}
};
</script>



// WEBPACK FOOTER //
// src/page/addCollectFees/advanceEnrollmentFee.vue